export const REQUEST_LOGIN_ASYNC = 'REQUEST_LOGIN_ASYNC';
export const REQUEST_LOGIN_SUCCESS = 'REQUEST_LOGIN_SUCCESS';
export const REQUEST_LOGIN_ERROR = 'REQUEST_LOGIN_ERROR';

export const ACTIVE_USER = 'ACTIVE_USER';
export const ACTIVE_USER_SUCCESS = 'ACTIVE_USER_SUCCESS';
export const ACTIVE_USER_FAILED = 'ACTIVE_USER_FAILED';

export const ACTIVE_EXIST_USER_ASYNC = 'ACTIVE_EXIST_USER_ASYNC';

export const CONFIRM_EMAIL = 'CONFIRM_EMAIL';
export const CONFIRM_EMAIL_SUCCESS = 'CONFIRM_EMAIL_SUCCESS';
export const CONFIRM_EMAIL_FAILED = 'CONFIRM_EMAIL_FAILED';

export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILED = 'RESET_PASSWORD_FAILED';

export const REFRESH_TOKEN_ASYNC = 'REFRESH_TOKEN_ASYNC';
export const REFRESH_TOKEN_SUCCESS = 'REFRESH_TOKEN_SUCCESS';
export const REFRESH_TOKEN_ERROR = 'REFRESH_TOKEN_ERROR';

export const OAUTH_SSO = 'OAUTH_SSO';
export const OAUTH_SSO_SUCCESS = 'OAUTH_SSO_SUCCESS';
export const OAUTH_SSO_FAILED = 'OAUTH_SSO_FAILED';
export const REFRESHING_TOKEN = 'REFRESHING_TOKEN';
export const SELECT_LIST_BUILDER_USER_ASYNC = 'SELECT_LIST_BUILDER_USER_ASYNC';
export const SELECT_LISTS_BUILDER_USER_ASYNC = 'SELECT_LISTS_BUILDER_USER_ASYNC';
export const SELECT_LISTS_BUILDER_USER_SUCCESS = 'SELECT_LISTS_BUILDER_USER_SUCCESS';
export const SELECT_LIST_BUILDER_USER_SUCCESS =
  'SELECT_LIST_BUILDER_USER_SUCCESS';
export const SELECT_LIST_ADMIN_SUPER_ADMIN_ASYNC =
  'SELECT_LIST_ADMIN_SUPER_ADMIN_ASYNC';
export const SELECT_LIST_ADMIN_SUPER_ADMIN_SUCCESS =
  'SELECT_LIST_ADMIN_SUPER_ADMIN_SUCCESS';
export const GET_CURRENT_USER_ASYNC = 'GET_CURRENT_USER_ASYNC';
export const GET_CURRENT_USER_SUCCESS = 'GET_CURRENT_USER_SUCCESS';

export const GET_USER_BY_CLIENT_ID_AND_EMAIL_ASYNC =
  'GET_USER_BY_CLIENT_ID_AND_EMAIL_ASYNC';
export const SEND_REQUEST_FORGOT_PASSWORD_ASYNC =
  'SEND_REQUEST_FORGOT_PASSWORD_ASYNC';

export const SSO_ASYNC = 'SSO_ASYNC';
export const VERIFY_TOKEN_ACTIVE_USER_ASYNC = 'VERIFY_TOKEN_ACTIVE_USER_ASYNC';
export const VERIFY_TOKEN_CONFIRM_EMAIL_ASYNC =
  'VERIFY_TOKEN_CONFIRM_EMAIL_ASYNC';
export const VERIFY_TOKEN_RESET_PASSWORD_ASYNC =
  'VERIFY_TOKEN_RESET_PASSWORD_ASYNC';

export const GET_IZENDA_TOKEN_ASYNC = 'GET_IZENDA_TOKEN_ASYNC';
export const GET_IZENDA_TOKEN_SUCCESS = 'GET_IZENDA_TOKEN_SUCCESS';
export const GET_IZENDA_TOKEN_ERROR = 'GET_IZENDA_TOKEN_ERROR';

export const LOGOUT = 'LOGOUT';

export const ADD_ITEM_TO_IMPORT_DATA = 'ADD_ITEM_TO_IMPORT_DATA';
export const REMOVE_ITEM_IN_IMPORT_DATA = 'REMOVE_ITEM_IN_IMPORT_DATA';

export const GET_EXTRANAL_USER_AUTH_TOKEN_ASYNC = 'GET_EXTRANAL_USER_AUTH_TOKEN_ASYNC';
export const GET_EXTRANAL_USER_AUTH_TOKEN_SUCCESS = 'GET_EXTRANAL_USER_AUTH_TOKEN_SUCCESS';
export const GET_EXTRANAL_USER_AUTH_TOKEN_ERROR = 'GET_EXTRANAL_USER_AUTH_TOKEN_ERROR';
export const SET_HO_BRANDING_LOGO_COLOR = 'SET_HO_BRANDING_LOGO_COLOR';
export const SET_HO_BRANDING_LOGO_COLOR_SUCCESS = 'SET_HO_BRANDING_LOGO_COLOR_SUCCESS';



// WEBPACK FOOTER //
// ./src/Auth/constants.js